<template>
    <div id="share">
        <div id="notice">
            <img src="../assets/images/img_26.png" alt="" class="imgsIcon">
            <swiper class="roll-ul" :options="swiperOption" ref="mySwiper" v-if="topMovieLists.length>0" >
                <swiper-slide v-for="(item,index) in topMovieLists" :key="index" class="roll-li">
                    <div class="slideLeft">
                        <img src="../assets/images/photo.png" alt="">
                        <div class="text">{{item.name}}<span>{{item.num}}</span>{{item.unit}}</div>
                    </div>
                    <div class="slideRight">{{item.timer}}</div>
                </swiper-slide>
            </swiper>
        </div>
        
        <!-- <div class="btns">立即赚钱</div> -->
        <img @click="go_install" src="../assets/images/img_74.png" alt="" class="btns">


        <!--非safari浏览器的蒙板弹窗-->
        <div v-if="isShowOpenSafari" class="safari_open_wrap" @touchmove.prevent>
            <div class="safari_open_dailog">
                <img class="img_tag_show" src="../assets/images/show_toast.png">
            </div>
        </div>
        
    </div>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper';

    import { Dialog } from 'vant';

    export default {
        components:{
            swiper,
            swiperSlide
        },
        data() {
            return {
                swiperOption: {
                    notNextTick: true,
                    direction: "vertical",   //控制滚动的方向
                    paginationClickable: true,
                    autoplay: {
                        disableOnInteraction: false,
                        delay:3000  //这里需要注意，如果想每2秒去自动切换，直接autoplay:2000是失效的，
                    },
                    loop: true,
                    on:{
                        click:function(e){
                            console.log('公告')
                        }
                    }
                },
                topMovieLists: [
                    {name: "空気支付宝提现",num: 21,unit:'元',timer:'11:21'},
                    {name: "傻瓜爱着笨蛋支付宝提现",num: 66,unit:'元',timer:'13:22'},
                    {name: "蒋义样支付宝提现",num: 88,unit:'元',timer:'15:23'},
                    {name: "十發九中支付宝提现",num: 26,unit:'元',timer:'17:24'},
                    {name: "微笑总是美～支付宝提现",num: 12,unit:'元',timer:'16:23'},
                    {name: "鬼鬼༂支付宝提现",num: 36,unit:'元',timer:'18:29'}
                ],

                isShowOpenSafari: false, // 微信打开的链接需要蒙版引导
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                let datas = {
                    invite_code:this.$route.query.inviteCode
                }
                this.$http.POSTS('amway/setMasterInviteCode',datas,(res)=>{

                });
            },
            // 立即赚钱
            go_install() {
                if(this.getBrowserInfo() == 'weixin') {
                    this.isShowOpenSafari = true;
                }else if(this.getBrowserInfo() == 'safari'){
                    this.$router.push('/guide');
                }else {
                    Dialog.alert({
                        title: '温馨提示',
                        message: '不支持的浏览器，请使用苹果Safari浏览器打开此页面！'
                    });
                }
            },
            // 获取浏览器信息
            getBrowserInfo(){
                var ua = navigator.userAgent.toLocaleLowerCase();
                var browserType=null;
                if (ua.match(/firefox/) != null) {
                    browserType = "huohu";
                }else if (ua.match(/uc/) != null) {
                    browserType = "UC";
                } else if (ua.match(/baiduboxapp/) != null) {
                    browserType = "baidu";
                }else if (ua.match(/tencent/) != null || ua.match(/qqbrowse/) != null) {
                    browserType = "QQ";
                }else if (ua.match(/qhbrowser/) != null) {
                    browserType = '360'
                }else if (ua.match(/safari/) != null) {
                    browserType = "safari";
                }else if(ua.match(/micromessenger/) !=null ){
                    browserType = "weixin";
                }
                if(browserType=='baidu') return 'baidu';
                if(browserType=='safari'){
                    return 'safari';
                }else if(browserType=='weixin'){
                    return 'weixin';
                }else{
                    return 'common';
                }
            },
        },
    }
</script>

<style lang="less" scoped>
    #share{
        width: 100%;
        height: 100%;
        background-image: url('../assets/images/img_70.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        display: flex;
        position: relative;
        // 公告
        #notice{
            width:345px;
            height:35px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,1);
            margin: 14px;
            line-height: 35px;
            display: flex;
            flex-direction: row;
            .imgsIcon{
                width: 49px;
                height: 23px;
                margin: auto 0;
                margin-left: 10px;
            }
            .roll-ul{
                .roll-li{
                    width: 266px;
                    margin: 0 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size:13px;
                    .slideLeft{
                        display: flex;
                        align-items: center;
                        img{
                            width: 22px;
                            height: 22px;
                            margin-right: 6px;
                        }
                        .text{
                            span{
                                color: #E50113;
                            }
                        }
                    }
                    .slideRight{

                    }
                }
            }
        }
        // 按钮
        .btns{
            width: 195px;
            height: 40px;
            position: absolute;
            left: 90px;
            bottom: 50px;
        }

        /*非safari浏览器的蒙板弹窗*/
        .safari_open_wrap{
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.64);
            z-index: 10;
        }
        .safari_open_dailog{
            text-align: right;
        }
        .img_tag_show{
            width: 5.333333rem;
            height: 2.373333rem;
            margin: .285714rem 0.571429rem 0 0;
        }
    }
</style>